import type { IMenuSection } from '@fondationcss/ui';

/**
 * Menu latéral, aligné sur le patron de `frontend/src/sidebar-items.ts` de
 * Parcours : le socle attend `Menus: IMenuSection[]` (des sections contenant des
 * `groups`), et non la liste legacy `SidebarItems` que le gabarit
 * fondation-sample-project utilise encore et qui ne rend rien.
 *
 * `module` + `permissions` reprennent exactement ce que `DashboardModule`
 * déclare côté serveur (`MODULE_NAME` = `Scheduler.Dashboard`,
 * `PERMISSION_ADMINISTRATOR` = `Administrateur`). Le scheduler est un outil
 * d'exploitation : toutes ses vues sont réservées à l'administrateur, et c'est
 * de toute façon le serveur qui tranche — chaque route `/api/dashboard/**`
 * répond 403 sans cette permission.
 */
const MODULE = 'Scheduler.Dashboard';
const ADMIN = `${MODULE}.Administrateur`;

export const menus: IMenuSection[] = [
  {
    title: 'Solveur',
    icon: 'gauge-high',
    iconOnly: true,
    maxGroups: 10,
    module: MODULE,
    permissions: [ADMIN],
    groups: [
      { title: 'Vue d’ensemble', icon: 'chart-simple', to: '/' },
      { title: 'Environnements', icon: 'server', to: '/environnements' },
      { title: 'Tous les jobs', icon: 'list-check', to: '/jobs' },
      { title: 'File en direct', icon: 'bolt', to: '/file' },
      { title: 'Comparaison', icon: 'chart-line', to: '/comparaison' },
      { title: 'Versions du solveur', icon: 'code-branch', to: '/versions' },
      { title: 'Locataires', icon: 'key', to: '/locataires' },
    ],
  },
];
